import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IconService } from '@pgaoc/shared-lib';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true,
  providers: [],
})
export class App {
  private iconService = inject(IconService);
}
